"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2675],{

/***/ 98733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ FloorPosition; },
/* harmony export */   "F": function() { return /* binding */ Currency; },
/* harmony export */   "Kp": function() { return /* binding */ StateOfMaintenance; },
/* harmony export */   "MO": function() { return /* binding */ Furnishings; },
/* harmony export */   "Ok": function() { return /* binding */ PoiType; },
/* harmony export */   "Sr": function() { return /* binding */ SortDirection; },
/* harmony export */   "YY": function() { return /* binding */ CoolingSystem; },
/* harmony export */   "af": function() { return /* binding */ StateOfMaintenanceFilter; },
/* harmony export */   "eq": function() { return /* binding */ FloorShift; },
/* harmony export */   "oy": function() { return /* binding */ Kitchen; },
/* harmony export */   "uV": function() { return /* binding */ StateAtDeed; },
/* harmony export */   "y8": function() { return /* binding */ EnergyRating; }
/* harmony export */ });
/* unused harmony exports CardinalPoint, Country, EnergyRatingCategory, EstateRegistryClass, FloorFilter, Glazing, HeatingSystem, HeatingSystemFilter, Language, ResidentialType, ResidentialTypeFilter, SortBy, StateAtDeedFilter, UpdateResult, AreasDocument, CitiesDocument, getSdk */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84283);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48000);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query areas($filter: AreaFilter) {\n  areas(filter: $filter) {\n    value\n    name\n    cities {\n      value\n    }\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    query cities($filter: FilterByCountry!) {\n  cities(filter: $filter) {\n    name\n    slug\n    center\n    value\n    description {\n      language\n      text\n    }\n    referenceArea\n    zones {\n      label\n      slug\n    }\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var CardinalPoint;
(function(CardinalPoint) {
    CardinalPoint["East"] = "EAST";
    CardinalPoint["North"] = "NORTH";
    CardinalPoint["South"] = "SOUTH";
    CardinalPoint["West"] = "WEST";
})(CardinalPoint || (CardinalPoint = {}));
var CoolingSystem;
(function(CoolingSystem) {
    CoolingSystem["Autonomous"] = "AUTONOMOUS";
    CoolingSystem["None"] = "NONE";
    CoolingSystem["ReadyForInstallation"] = "READY_FOR_INSTALLATION";
    CoolingSystem["Shared"] = "SHARED";
})(CoolingSystem || (CoolingSystem = {}));
var Country;
(function(Country) {
    Country["Italy"] = "ITALY";
    Country["Spain"] = "SPAIN";
})(Country || (Country = {}));
var Currency;
(function(Currency) {
    Currency["Eur"] = "EUR";
})(Currency || (Currency = {}));
var EnergyRating;
(function(EnergyRating) {
    EnergyRating["A"] = "A";
    EnergyRating["A1"] = "A1";
    EnergyRating["A2"] = "A2";
    EnergyRating["A3"] = "A3";
    EnergyRating["A4"] = "A4";
    EnergyRating["Aplus"] = "APLUS";
    EnergyRating["B"] = "B";
    EnergyRating["C"] = "C";
    EnergyRating["D"] = "D";
    EnergyRating["E"] = "E";
    EnergyRating["F"] = "F";
    EnergyRating["G"] = "G";
    EnergyRating["None"] = "NONE";
    EnergyRating["PendingRequest"] = "PENDING_REQUEST";
})(EnergyRating || (EnergyRating = {}));
var EnergyRatingCategory;
(function(EnergyRatingCategory) {
    EnergyRatingCategory["Ace"] = "ACE";
    EnergyRatingCategory["Ape"] = "APE";
})(EnergyRatingCategory || (EnergyRatingCategory = {}));
var EstateRegistryClass;
(function(EstateRegistryClass) {
    EstateRegistryClass["F2"] = "F2";
    EstateRegistryClass["A7"] = "A7";
    EstateRegistryClass["B3"] = "B3";
    EstateRegistryClass["E9"] = "E9";
    EstateRegistryClass["B4"] = "B4";
    EstateRegistryClass["A3"] = "A3";
    EstateRegistryClass["B7"] = "B7";
    EstateRegistryClass["A8"] = "A8";
    EstateRegistryClass["C5"] = "C5";
    EstateRegistryClass["F3"] = "F3";
    EstateRegistryClass["B8"] = "B8";
    EstateRegistryClass["E4"] = "E4";
    EstateRegistryClass["C2"] = "C2";
    EstateRegistryClass["F6"] = "F6";
    EstateRegistryClass["C4"] = "C4";
    EstateRegistryClass["A9"] = "A9";
    EstateRegistryClass["None"] = "NONE";
    EstateRegistryClass["D7"] = "D7";
    EstateRegistryClass["A1"] = "A1";
    EstateRegistryClass["D1"] = "D1";
    EstateRegistryClass["C3"] = "C3";
    EstateRegistryClass["D5"] = "D5";
    EstateRegistryClass["A2"] = "A2";
    EstateRegistryClass["B1"] = "B1";
    EstateRegistryClass["A5"] = "A5";
    EstateRegistryClass["F1"] = "F1";
    EstateRegistryClass["B2"] = "B2";
    EstateRegistryClass["D6"] = "D6";
    EstateRegistryClass["C6"] = "C6";
    EstateRegistryClass["A10"] = "A10";
    EstateRegistryClass["C1"] = "C1";
    EstateRegistryClass["B6"] = "B6";
    EstateRegistryClass["F4"] = "F4";
    EstateRegistryClass["F5"] = "F5";
    EstateRegistryClass["E3"] = "E3";
    EstateRegistryClass["A11"] = "A11";
    EstateRegistryClass["D3"] = "D3";
    EstateRegistryClass["E7"] = "E7";
    EstateRegistryClass["D4"] = "D4";
    EstateRegistryClass["E1"] = "E1";
    EstateRegistryClass["B5"] = "B5";
    EstateRegistryClass["A4"] = "A4";
    EstateRegistryClass["D10"] = "D10";
    EstateRegistryClass["E8"] = "E8";
    EstateRegistryClass["C7"] = "C7";
    EstateRegistryClass["E5"] = "E5";
    EstateRegistryClass["D8"] = "D8";
    EstateRegistryClass["E6"] = "E6";
    EstateRegistryClass["E2"] = "E2";
    EstateRegistryClass["D2"] = "D2";
    EstateRegistryClass["D9"] = "D9";
    EstateRegistryClass["A6"] = "A6";
})(EstateRegistryClass || (EstateRegistryClass = {}));
var FloorFilter;
(function(FloorFilter) {
    FloorFilter["Any"] = "ANY";
    FloorFilter["Basement"] = "BASEMENT";
    FloorFilter["GroundFloor"] = "GROUND_FLOOR";
    FloorFilter["LastFloor"] = "LAST_FLOOR";
    FloorFilter["MidFloor"] = "MID_FLOOR";
    FloorFilter["Raised"] = "RAISED";
})(FloorFilter || (FloorFilter = {}));
var FloorPosition;
(function(FloorPosition) {
    FloorPosition["Basement"] = "BASEMENT";
    FloorPosition["GroundFloor"] = "GROUND_FLOOR";
    FloorPosition["LastFloor"] = "LAST_FLOOR";
    FloorPosition["MidFloor"] = "MID_FLOOR";
    FloorPosition["Raised"] = "RAISED";
})(FloorPosition || (FloorPosition = {}));
var FloorShift;
(function(FloorShift) {
    FloorShift["Lowered"] = "LOWERED";
    FloorShift["None"] = "NONE";
    FloorShift["Raised"] = "RAISED";
})(FloorShift || (FloorShift = {}));
var Furnishings;
(function(Furnishings) {
    Furnishings["FullyFurnished"] = "FULLY_FURNISHED";
    Furnishings["NotFurnished"] = "NOT_FURNISHED";
    Furnishings["PartiallyFurnished"] = "PARTIALLY_FURNISHED";
})(Furnishings || (Furnishings = {}));
var Glazing;
(function(Glazing) {
    Glazing["Double"] = "DOUBLE";
    Glazing["Single"] = "SINGLE";
    Glazing["Triple"] = "TRIPLE";
})(Glazing || (Glazing = {}));
var HeatingSystem;
(function(HeatingSystem) {
    HeatingSystem["Autonomous"] = "AUTONOMOUS";
    HeatingSystem["None"] = "NONE";
    HeatingSystem["Shared"] = "SHARED";
})(HeatingSystem || (HeatingSystem = {}));
var HeatingSystemFilter;
(function(HeatingSystemFilter) {
    HeatingSystemFilter["Any"] = "ANY";
    HeatingSystemFilter["Autonomous"] = "AUTONOMOUS";
    HeatingSystemFilter["None"] = "NONE";
    HeatingSystemFilter["Shared"] = "SHARED";
})(HeatingSystemFilter || (HeatingSystemFilter = {}));
var Kitchen;
(function(Kitchen) {
    Kitchen["Habitable"] = "HABITABLE";
    Kitchen["HalfHabitable"] = "HALF_HABITABLE";
    Kitchen["Kitchenette"] = "KITCHENETTE";
    Kitchen["Open"] = "OPEN";
})(Kitchen || (Kitchen = {}));
var Language;
(function(Language) {
    Language["En"] = "EN";
    Language["Es"] = "ES";
    Language["It"] = "IT";
})(Language || (Language = {}));
var PoiType;
(function(PoiType) {
    PoiType["BusStop"] = "BUS_STOP";
    PoiType["School"] = "SCHOOL";
    PoiType["Shop"] = "SHOP";
    PoiType["SubwayStation"] = "SUBWAY_STATION";
    PoiType["TrainStation"] = "TRAIN_STATION";
    PoiType["TramStop"] = "TRAM_STOP";
})(PoiType || (PoiType = {}));
var ResidentialType;
(function(ResidentialType) {
    ResidentialType["Apartment"] = "APARTMENT";
    ResidentialType["Attic"] = "ATTIC";
    ResidentialType["House"] = "HOUSE";
    ResidentialType["Loft"] = "LOFT";
    ResidentialType["Mansard"] = "MANSARD";
    ResidentialType["Townhouse"] = "TOWNHOUSE";
    ResidentialType["Villa"] = "VILLA";
})(ResidentialType || (ResidentialType = {}));
var ResidentialTypeFilter;
(function(ResidentialTypeFilter) {
    ResidentialTypeFilter["Any"] = "ANY";
    ResidentialTypeFilter["Apartment"] = "APARTMENT";
    ResidentialTypeFilter["Attic"] = "ATTIC";
    ResidentialTypeFilter["House"] = "HOUSE";
    ResidentialTypeFilter["Loft"] = "LOFT";
    ResidentialTypeFilter["Mansard"] = "MANSARD";
    ResidentialTypeFilter["Townhouse"] = "TOWNHOUSE";
    ResidentialTypeFilter["Villa"] = "VILLA";
})(ResidentialTypeFilter || (ResidentialTypeFilter = {}));
var SortBy;
(function(SortBy) {
    SortBy["Area"] = "AREA";
    SortBy["Date"] = "DATE";
    SortBy["Price"] = "PRICE";
})(SortBy || (SortBy = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
var StateAtDeed;
(function(StateAtDeed) {
    StateAtDeed["BareOwnership"] = "BARE_OWNERSHIP";
    StateAtDeed["Free"] = "FREE";
    StateAtDeed["Occupied"] = "OCCUPIED";
    StateAtDeed["Rented"] = "RENTED";
    StateAtDeed["Unknown"] = "UNKNOWN";
})(StateAtDeed || (StateAtDeed = {}));
var StateAtDeedFilter;
(function(StateAtDeedFilter) {
    StateAtDeedFilter["Any"] = "ANY";
    StateAtDeedFilter["BareOwnership"] = "BARE_OWNERSHIP";
    StateAtDeedFilter["Free"] = "FREE";
    StateAtDeedFilter["Occupied"] = "OCCUPIED";
    StateAtDeedFilter["Rented"] = "RENTED";
    StateAtDeedFilter["Unknown"] = "UNKNOWN";
})(StateAtDeedFilter || (StateAtDeedFilter = {}));
var StateOfMaintenance;
(function(StateOfMaintenance) {
    StateOfMaintenance["Habitable"] = "HABITABLE";
    StateOfMaintenance["NeedRenovation"] = "NEED_RENOVATION";
    StateOfMaintenance["New"] = "NEW";
    StateOfMaintenance["Renovated"] = "RENOVATED";
    StateOfMaintenance["UnderConstruction"] = "UNDER_CONSTRUCTION";
})(StateOfMaintenance || (StateOfMaintenance = {}));
var StateOfMaintenanceFilter;
(function(StateOfMaintenanceFilter) {
    StateOfMaintenanceFilter["Any"] = "ANY";
    StateOfMaintenanceFilter["Habitable"] = "HABITABLE";
    StateOfMaintenanceFilter["NeedRenovation"] = "NEED_RENOVATION";
    StateOfMaintenanceFilter["New"] = "NEW";
    StateOfMaintenanceFilter["Renovated"] = "RENOVATED";
    StateOfMaintenanceFilter["UnderConstruction"] = "UNDER_CONSTRUCTION";
})(StateOfMaintenanceFilter || (StateOfMaintenanceFilter = {}));
var UpdateResult;
(function(UpdateResult) {
    UpdateResult["Created"] = "CREATED";
    UpdateResult["Deleted"] = "DELETED";
    UpdateResult["Updated"] = "UPDATED";
})(UpdateResult || (UpdateResult = {}));
var AreasDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject());
var CitiesDocument = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject1());
var defaultWrapper = function(action, _operationName) {
    return action();
};
var AreasDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(AreasDocument);
var CitiesDocumentString = (0,graphql__WEBPACK_IMPORTED_MODULE_2__.print)(CitiesDocument);
function getSdk(client) {
    var withWrapper = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultWrapper;
    return {
        areas: function areas(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(AreasDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "areas");
        },
        cities: function cities(variables, requestHeaders) {
            return withWrapper(function(wrappedRequestHeaders) {
                return client.rawRequest(CitiesDocumentString, variables, _object_spread({}, requestHeaders, wrappedRequestHeaders));
            }, "cities");
        }
    };
}


/***/ }),

/***/ 76362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CasavoInventory; }
/* harmony export */ });
var CasavoInventory;
(function(CasavoInventory) {
    CasavoInventory["Agency"] = "oda";
    CasavoInventory["Priority"] = "priority";
    CasavoInventory["Third_Party"] = "third_party";
    CasavoInventory["iBuyer"] = "ibuyer";
})(CasavoInventory || (CasavoInventory = {}));


/***/ }),

/***/ 58577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatPrice; }
/* harmony export */ });
var formatPrice = function(price, locale, allowDecimals) {
    if (price && price.cents) {
        return Intl ? new Intl.NumberFormat(locale, {
            currency: "EUR",
            maximumFractionDigits: 2,
            style: "currency"
        }).format(allowDecimals ? price.cents / 100 : Math.floor(price.cents / 100)).replace(/\D00(?=\D*$)/, "") : "".concat(Math.floor(price.cents / 100), " €");
    }
    return "";
};


/***/ }),

/***/ 22862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTranslatedTitle; }
/* harmony export */ });
function getTranslatedTitle() {
    var titles = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], language = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var translatedTitle = titles === null || titles === void 0 ? void 0 : titles.find(function(d) {
        var ref;
        return ((ref = d.language) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (language === null || language === void 0 ? void 0 : language.toLowerCase());
    });
    if (translatedTitle && (translatedTitle === null || translatedTitle === void 0 ? void 0 : translatedTitle.text)) {
        return translatedTitle.text;
    }
    var ref1;
    return titles.length === 0 ? "" : (ref1 = (ref = titles[0]) === null || ref === void 0 ? void 0 : ref.text) !== null && ref1 !== void 0 ? ref1 : "";
}


/***/ }),

/***/ 69631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ie": function() { return /* binding */ nikaListingsToLegacyListings; },
  "Vy": function() { return /* binding */ nikaMetaToLegacyMeta; }
});

// UNUSED EXPORTS: formatYear, mapBox, mapFloorplan, mapPoi, mapTitle, mapVirtualTours

// EXTERNAL MODULE: ./src/types/graphql-generated-types.ts
var graphql_generated_types = __webpack_require__(98733);
// EXTERNAL MODULE: ./src/types/listing.ts
var listing = __webpack_require__(76362);
;// CONCATENATED MODULE: ./src/types/nika.ts
var Amenities;
(function(Amenities) {
    Amenities["alarm"] = "alarm";
    Amenities["barrier_access"] = "barrier_access";
    Amenities["barrier_friendly"] = "barrier_friendly";
    Amenities["concierge"] = "concierge";
    Amenities["door_armor"] = "armored_door";
    Amenities["elevator"] = "elevator";
    Amenities["fiber"] = "fiber";
    Amenities["fireplace"] = "fireplace";
    Amenities["gate_electric"] = "gate_electric";
    Amenities["home_automation"] = "home_automation";
    Amenities["hydromassage"] = "hydromassage";
    Amenities["interphone_video"] = "interphone_video";
    Amenities["shared_garden"] = "shared_garden";
    Amenities["shared_pool"] = "shared_pool";
    Amenities["tennis_court"] = "tennis_court";
    Amenities["tv_antenna"] = "tv_antenna";
    Amenities["tv_sat"] = "tv_sat";
    Amenities["wall_cabinet"] = "wall_cabinet";
})(Amenities || (Amenities = {}));

;// CONCATENATED MODULE: ./src/utils/nika/listing-mapper.ts



var KitchenMap = {
    full: graphql_generated_types/* Kitchen.Habitable */.oy.Habitable,
    half: graphql_generated_types/* Kitchen.HalfHabitable */.oy.HalfHabitable,
    mini: graphql_generated_types/* Kitchen.Kitchenette */.oy.Kitchenette,
    open: graphql_generated_types/* Kitchen.Open */.oy.Open
};
var FloorPositionMap = {
    basement: graphql_generated_types/* FloorPosition.Basement */.$K.Basement,
    ground: graphql_generated_types/* FloorPosition.GroundFloor */.$K.GroundFloor,
    last: graphql_generated_types/* FloorPosition.LastFloor */.$K.LastFloor,
    mid: graphql_generated_types/* FloorPosition.MidFloor */.$K.MidFloor
};
var FloorShiftMap = {
    lowered: graphql_generated_types/* FloorShift.Lowered */.eq.Lowered,
    null: graphql_generated_types/* FloorShift.None */.eq.None,
    raised: graphql_generated_types/* FloorShift.Raised */.eq.Raised
};
var CoolingSystemMap = {
    central: graphql_generated_types/* CoolingSystem.Shared */.YY.Shared,
    independent: graphql_generated_types/* CoolingSystem.Autonomous */.YY.Autonomous,
    none: graphql_generated_types/* CoolingSystem.None */.YY.None,
    ready: graphql_generated_types/* CoolingSystem.ReadyForInstallation */.YY.ReadyForInstallation
};
var HeatingSystemMap = {
    central: graphql_generated_types/* CoolingSystem.Shared */.YY.Shared,
    independent: graphql_generated_types/* CoolingSystem.Autonomous */.YY.Autonomous,
    none: graphql_generated_types/* CoolingSystem.None */.YY.None
};
var StateOfMaintenanceMap = {
    construction: graphql_generated_types/* StateOfMaintenance.UnderConstruction */.Kp.UnderConstruction,
    habitable: graphql_generated_types/* StateOfMaintenance.Habitable */.Kp.Habitable,
    need_renovation: graphql_generated_types/* StateOfMaintenance.NeedRenovation */.Kp.NeedRenovation,
    new: graphql_generated_types/* StateOfMaintenance.New */.Kp.New,
    renovated: graphql_generated_types/* StateOfMaintenance.Renovated */.Kp.Renovated
};
var StateAtDeedMap = {
    bare: graphql_generated_types/* StateAtDeed.BareOwnership */.uV.BareOwnership,
    free: graphql_generated_types/* StateAtDeed.Free */.uV.Free,
    occupied: graphql_generated_types/* StateAtDeed.Occupied */.uV.Occupied,
    rented: graphql_generated_types/* StateAtDeed.Rented */.uV.Rented,
    unknown: graphql_generated_types/* StateAtDeed.Unknown */.uV.Unknown
};
var FurnishingsMap = {
    full: graphql_generated_types/* Furnishings.FullyFurnished */.MO.FullyFurnished,
    none: graphql_generated_types/* Furnishings.NotFurnished */.MO.NotFurnished,
    partial: graphql_generated_types/* Furnishings.PartiallyFurnished */.MO.PartiallyFurnished
};
var InventoryMap = {
    ibuyer: listing/* CasavoInventory.iBuyer */.M.iBuyer,
    null: listing/* CasavoInventory.Third_Party */.M.Third_Party,
    oda: listing/* CasavoInventory.Agency */.M.Agency
};
var EnergyRatingMap = {
    A: graphql_generated_types/* EnergyRating.A */.y8.A,
    A1: graphql_generated_types/* EnergyRating.A1 */.y8.A1,
    A2: graphql_generated_types/* EnergyRating.A2 */.y8.A2,
    A3: graphql_generated_types/* EnergyRating.A3 */.y8.A3,
    A4: graphql_generated_types/* EnergyRating.A4 */.y8.A4,
    APLUS: graphql_generated_types/* EnergyRating.Aplus */.y8.Aplus,
    B: graphql_generated_types/* EnergyRating.B */.y8.B,
    C: graphql_generated_types/* EnergyRating.C */.y8.C,
    D: graphql_generated_types/* EnergyRating.D */.y8.D,
    E: graphql_generated_types/* EnergyRating.E */.y8.E,
    F: graphql_generated_types/* EnergyRating.F */.y8.F,
    G: graphql_generated_types/* EnergyRating.G */.y8.G,
    none: graphql_generated_types/* EnergyRating.None */.y8.None,
    pending: graphql_generated_types/* EnergyRating.PendingRequest */.y8.PendingRequest
};
function mapFloor(floor) {
    return {
        buildingFloor: floor.building,
        entireFloor: floor.entire,
        floorShift: FloorShiftMap[floor.shift]
    };
}
function mapCountry(country) {
    return ({
        es: "spain",
        fr: "france",
        it: "italy",
        pt: "portugal"
    })[country];
}
function mapDescription(description) {
    return {
        language: description.language.toUpperCase(),
        neighbourhoodDescription: description.neighbourhood,
        propertyDescription: description.property
    };
}
function mapTitle(description) {
    return {
        language: description.language,
        text: description.title
    };
}
function hasSegment(segment) {
    return segment && segment.length > 0;
}
function mapCardinal(direction) {
    return direction.toUpperCase();
}
//TODO: check price euro vs eurocents
function mapFurnishingProposal(data, x) {
    return {
        price: data.pricing_sell_value,
        url: x.url
    };
}
function mapPhotos(x) {
    return {
        isPrimary: x.is_primary,
        order: x.index,
        url: x.url
    };
}
/**
 *
 * @param date something like YYYY-MM-DD
 */ function formatYear(date) {
    return date && parseInt(date.split("-")[0]);
}
function mapFloorplan(data) {
    var ref, ref1;
    if (data === null || data === void 0 ? void 0 : (ref = data.media_floorplans) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) {
        return {
            url: data.media_floorplans[0].url
        };
    }
    return {};
}
function mapBox(nikaBox) {
    if (nikaBox.length === 0) return null;
    return {
        area: null,
        areas: null,
        counter: nikaBox.length
    };
}
var mapPoi = function(pois) {
    return pois.map(function(poi) {
        return {
            coordinates: {
                lat: poi.geo_location.coordinates[1],
                lon: poi.geo_location.coordinates[0]
            },
            distance: poi.distance,
            name: poi.label,
            poiType: poi.type.toUpperCase()
        };
    });
};
var mapVirtualTours = function(url) {
    return url ? {
        url: url
    } : null;
};
function nikaListingsToLegacyListings(data) {
    return {
        additionalInfo: {
            condo: data.property_belongs_condo,
            // FIXME this one seem unused
            condoFeesPerYear: data.pricing_fees_condo_value * 100,
            condoFeesPerYearCate: {
                // MEMO pricing_fees_condo_value is €, condoFeesPerYearCate in euro cents
                cents: data.pricing_fees_condo_value * 100,
                currency: data.pricing_fees_condo_unit
            },
            constructionYear: formatYear(data.property_date_construction),
            coolingSystem: CoolingSystemMap[data.property_system_cooling],
            energyPerformanceIndex: data.administrative_energy_performance_index,
            energyRating: EnergyRatingMap[data.administrative_energy_rating.value],
            energyRatingCategory: data.administrative_energy_rating.system,
            estateRegistryArea: data.administrative_area_registry,
            estateRegistryClass: data.administrative_class_registry.toUpperCase(),
            exposure: data.property_exposures.map(mapCardinal),
            furnishings: FurnishingsMap[data.property_state_furniture],
            glazing: (data.property_windows_glazing || "single").toUpperCase(),
            heatingSystem: HeatingSystemMap[data.property_system_heating],
            kitchen: data.property_type_kitchen ? KitchenMap[data.property_type_kitchen] : null,
            lastRenovationYear: formatYear(data.property_date_renovation),
            stateAtDeed: StateAtDeedMap[data.administrative_state_deed] || "unknown",
            superCondo: false,
            views: data.property_views
        },
        addressesCate: {
            street: data.geo_street,
            streetNumber: data.geo_street_number,
            zipCode: data.geo_zip
        },
        characteristics: {
            balconies: {
                counter: data.property_segments_balcony.length
            },
            bathrooms: data.property_rooms_bath,
            bedrooms: data.property_rooms_bed,
            rooms: data.property_rooms_all,
            stateOfMaintenance: StateOfMaintenanceMap[data.property_state_maintenance],
            terraces: {
                counter: data.property_segments_terrace.length
            }
        },
        contactInfo: {
            agencyAddress: data.contacts && data.contacts.address,
            agencyLogo: null,
            agencyName: data.contacts && data.contacts.name,
            ownedByCasavo: data.inventory != null,
            telephoneNumberContact: data.contacts && data.contacts.phone
        },
        coordinates: {
            lat: data.geo_location.coordinates[1],
            lon: data.geo_location.coordinates[0]
        },
        country: mapCountry(data.geo_country),
        descriptions: data.descriptions.map(mapDescription),
        detail: {
            buildingFloors: data.property_floor_building,
            casavoDirectSale: data.sales_pipeline === "direct",
            city: data.geo_city,
            commercialArea: data.administrative_area_raw,
            entireBuilding: data.property_is_entire_building,
            entranceFloor: data.property_floor_entrance,
            exclusiveSellingMandate: false,
            floorPosition: [
                FloorPositionMap[data.property_floor_position]
            ],
            floors: data.property_floors.map(mapFloor),
            inventory: InventoryMap[data.inventory],
            privateNegotiation: data.pricing_sell_value === null,
            salesPipeline: data.sales_pipeline,
            sellingPrices: {
                cents: data.pricing_sell_value * 100,
                currency: data.pricing_sell_unit
            },
            sellingUnitId: data.selling_unit_id,
            titles: data.titles.map(mapTitle),
            transactionId: data.transaction_id,
            zone: data.geo_zone ? {
                label: data.geo_labels.zone,
                slug: data.geo_zone
            } : null
        },
        furnishingProposals: data.media_furnishing_proposals.length > 0 ? data.media_furnishing_proposals.map(function(x) {
            return mapFurnishingProposal(data, x);
        })[0] : null,
        id: data.id,
        insertedAt: data.created_at.toString(),
        photos: data.media_pictures.map(mapPhotos),
        planimetries: mapFloorplan(data),
        pointsOfInterest: mapPoi(data.geo_pois),
        publicUrls: null,
        publishedAt: data.created_at.toString(),
        ranking: 0,
        residentialType: data.property_type,
        services: {
            alarmSystem: data.amenities.includes(Amenities.alarm),
            armoredDoor: data.amenities.includes(Amenities.door_armor),
            basement: hasSegment(data.property_segments_basement),
            box: mapBox(data.property_segments_box),
            conciergeService: data.amenities.includes(Amenities.concierge),
            disabledAccess: data.amenities.includes(Amenities.barrier_access),
            disabledFriendly: data.amenities.includes(Amenities.barrier_friendly),
            electricGate: data.amenities.includes(Amenities.gate_electric),
            elevator: data.amenities.includes(Amenities.elevator),
            entranceVideoPhone: data.amenities.includes(Amenities.interphone_video),
            fastInternet: data.amenities.includes(Amenities.fiber),
            fireplace: data.amenities.includes(Amenities.fireplace),
            garden: data.property_feature_garden,
            gardenArea: data.property_segments_garden.map(function(x) {
                return x.area;
            }).reduce(function(a, b) {
                return a + b;
            }, 0),
            garret: hasSegment(data.property_segments_garret),
            homeAutomationSystem: data.amenities.includes(Amenities.home_automation),
            hydromassage: data.amenities.includes(Amenities.hydromassage),
            parkingSpaces: data.property_parking_spaces > 0,
            pool: data.property_feature_pool,
            recreationRoom: hasSegment(data.property_segments_recreative),
            satelliteSystem: data.amenities.includes(Amenities.tv_sat),
            sharedPool: data.amenities.includes(Amenities.shared_pool),
            tennisCourt: data.amenities.includes(Amenities.tennis_court),
            tvSystem: data.amenities.includes(Amenities.tv_antenna),
            walkingArea: data.administrative_area_net,
            wallCabinet: data.amenities.includes(Amenities.wall_cabinet)
        },
        showStreetNumber: data.geo_street_number != null,
        slug: data.id,
        updatedAt: data.updated_at,
        virtualTours: mapVirtualTours(data.url_tour_virtual)
    };
}
function nikaMetaToLegacyMeta(data, page) {
    if (data === undefined) return {
        hasMore: false,
        hasPrevious: false,
        inPage: 0,
        total: 0
    };
    return {
        hasMore: data.meta.has_more,
        hasPrevious: page > 1,
        inPage: data.data.length,
        total: data.meta.total_objects
    };
}


/***/ })

}]);